"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hinge = void 0;

var _index = require("../../../styles/index"); // -------------------------------------------
//   ANIMATIONS > HINGE
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ HINGE ~~~~~~~~~~ )))))))))) //


var hinge = {
  // ***** HINGE ***** //
  '@keyframes hinge': {
    '0%': {
      transformOrigin: 'top left',
      animationTimingFunction: 'ease-in-out'
    },
    '20%, 60%': {
      transform: 'rotate3d(0, 0, 1, 80deg)',
      transformOrigin: 'top left',
      animationTimingFunction: 'ease-in-out'
    },
    '40%, 80%': {
      transform: 'rotate3d(0, 0, 1, 60deg)',
      transformOrigin: 'top left',
      animationTimingFunction: 'ease-in-out',
      opacity: '1'
    },
    to: {
      transform: (0, _index.replacePXinStringWithEM)('translate3d(0, 700px, 0)'),
      opacity: '0'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.hinge = hinge;